"use strict";
// _smoothScroll.js

{
  const SPEED = 500;
  const BP = 768;

  // ヘッダー実高さを取得（取得不可時はSP/PC既定値にフォールバック）
  const getHeaderHeight = () => {
    const header = document.querySelector(".p-header");
    if (header) {
      const h = header.getBoundingClientRect().height;
      if (h) return h;
    }
    return window.innerWidth < BP ? 128 : 100;
  };

  // クリック時のスムーススクロール
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href || href === "#" || href === "#!") return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();

    const from = link.dataset.from;
    const url = new URL(location.href);

    if (from) {
      url.searchParams.set("from", from);
    }
    url.hash = href; // 例: '#shopPlan'
    history.replaceState(null, "", url.toString());

    const y = target.getBoundingClientRect().top + window.scrollY - getHeaderHeight();
    window.scrollTo({ top: y, behavior: "smooth" });
  });
}
